import React from 'react';
import Coupontable from '../../components/CouponPageComponents/Coupontable';
import Base from '../Base'
const Coupons = () => {
  return <Base>
    <Coupontable/>
  </Base>;
};

export default Coupons;
